import { errorHandler } from "@/services/toastHandler";

const initState = () => ({
  users: [],
  loading: false,
  error: "",
  totalPage: 0,
});

const getOrdersUrl = (userId) => {
  if (!userId) return `v1/cms/product/order`;
  return `v1/cms/product/order/user/${userId}`;
};

export default {
  namespaced: true,

  state: initState(),

  mutations: {
    SET_USERS: (s, users) => (s.users = users),
    SET_TOTAL_PAGE: (s, totalPage) => (s.totalPage = totalPage),
    LOADING: (s) => Object.assign(s, initState(), { loading: true }),
    SET_ERROR: (s, error) => (s.error = error),
    LOADED: (s) => (s.loading = false),
    RESET: (s) => Object.assign(s, initState()),
  },

  actions: {
    async getOrders({ commit }, { userId, ...params }) {
      commit("LOADING");
      try {
        const res = await this.$api.get(getOrdersUrl(userId), { params });
        const data = res?.data;
        if (!data) throw `Lấy danh sách đơn hàng thất bại`;
        const { total = 0 } = data.pagination || {};
        commit("SET_TOTAL_PAGE", total);
        return data?.data ?? [];
      } catch (e) {
        errorHandler(e);
      } finally {
        commit("LOADED");
      }
    },
  },
};
